import { __read, __spread } from "tslib";
import { isArray, isObject, isFunction, isBoolean, isUndefined, isNull } from './check';
function cloneDeep(origin) {
    if (origin && (!isObject(origin) || !isArray(origin)))
        return origin;
    var result = isObject(origin) ? {} : [];
    for (var key in origin) {
        result[key] = cloneDeep(origin[key]);
    }
    return result;
}
/**
 *
 * @param originFn
 * @param targetFn
 * @returns originFn & targetFn
 * 说明：合并函数会根据函数的返回值进行不同的处理
 * return 布尔值场景: originFn && targetFn
 * return 数组场景: [originFn(), targetFn()]
 */
export function mergeFunction(originFn, targetFn) {
    if (!targetFn || !originFn)
        return originFn || targetFn;
    return function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        var originResult = null;
        try {
            originResult = originFn.apply(null, arg);
            /* 若origin函数的返回值为boolean值，则合并后的布尔值一定受到origin */
            if (isBoolean(originResult)) {
                return originResult && targetFn.apply(null, arg);
            }
            else if (isArray(originResult)) { /* 数组类型 */
                return __spread(originResult, (targetFn.apply(null, arg)));
            }
            targetFn.apply(null, arg);
        }
        catch (e) {
            console.log(e);
        }
        return originResult;
    };
}
export function merge(origin, target) {
    if (!target || !origin)
        return cloneDeep(origin || target);
    var mergeOptions = cloneDeep(target);
    Object.keys(origin).forEach(function (key) {
        var value = origin[key];
        if (isArray(value)) {
            mergeOptions[key] = mergeOptions[key] || [];
            mergeOptions[key] = mergeOptions[key].concat(cloneDeep(value));
        }
        else if (isObject(value)) {
            mergeOptions[key] = value._cover_ ? cloneDeep(value.value) : merge(value, mergeOptions[key]);
        }
        else if (isFunction(value)) {
            mergeOptions[key] = mergeFunction(value, mergeOptions[key]);
        }
        else if (!isUndefined(value)) {
            mergeOptions[key] = value;
        }
    });
    return mergeOptions;
}
export function mergeBeforeSend(before, after) {
    var isBF = isFunction(before);
    var isAF = isFunction(after);
    if (isBF && isAF) {
        return function (ev, hint) {
            var result = before(ev, hint);
            if (isNull(result))
                return null;
            return after(result, hint);
        };
    }
    else if (isBF) {
        return before;
    }
    else if (isAF) {
        return after;
    }
    else {
        return function (ev) { return ev; };
    }
}
//# sourceMappingURL=merge.js.map